import React, { useEffect } from 'react';
import styles from '@/styles/components/file-dnd/PreviewFile.module.css';
import Loading from '@ax2/common/components/Loading';
interface FileData {
  fileData: any | null;
  setFileData: any | null;
  imageSrc: string | null;
}

const PreviewFile: React.FC<FileData> = props => {
  useEffect(() => {
    props.imageSrc && props.setFileData(null);
  }, [props.imageSrc]);

  return (
    <div className={styles.imageContainer}>
      {props.fileData && !props.imageSrc ? (
        <img
          src={props.fileData.src || URL.createObjectURL(props.fileData)}
          alt="Upload media preview"
          className={styles.image}
        />
      ) : props.imageSrc ? (
        <img src={props.imageSrc} alt="Preview" className={styles.image} />
      ) : (
        <Loading paddingVertical={0} />
      )}
    </div>
  );
};

export default PreviewFile;
